
import { IEnvironment, environmentGlobal } from "./environment.global";

export const environment: IEnvironment = {
    name: 'clifford-preprod',
    production: true,
    enterprise: environmentGlobal.enterprise,
    deviceFuncMap: environmentGlobal.deviceFuncMap,
    pluginConfig: {
        svcnow: {
            serverUrl: 'https://servicenow-plugin.partner.iadea.oniadea.com',
            contentUrl: 'https://servicenow-ccllpuat.for-workplace.com'
        }
    }
};